import { mediaUrlForPlayback } from './mediaUrls';

/** Story / project pipeline jobs that may publish a full exported MP4. */
export const STORY_SOCIAL_PUBLISH_JOB_TYPES = new Set([
  'export',
  'narration_pipeline',
  'narration_full_automation',
  'news_video_pipeline',
  'script_based_pipeline',
  'song_based_pipeline',
  'learning_tutorial_render',
  'story',
  'pitch_recording_pipeline',
  'reels_shorts_render',
  'avatar_cast_pipeline',
  'script_audio_align_pipeline',
]);

export function resolveTaskJobPublishVideoUrl(job) {
  if (!job || job.status !== 'completed') return '';

  const versions = Array.isArray(job.export_versions) ? job.export_versions : [];
  for (const ver of versions) {
    const href = mediaUrlForPlayback(ver.url, {
      localUrl: ver.local_url,
      s3Url: ver.url,
    });
    if (href) return href;
  }

  const creditUrl = job.credit_usage?.output_url;
  if (creditUrl) {
    const href = mediaUrlForPlayback(creditUrl);
    if (href) return href;
  }

  if (job.result_url) {
    const href = mediaUrlForPlayback(job.result_url);
    if (href) return href;
  }

  return '';
}

export function resolveExportVersionPublishUrl(version) {
  if (!version?.url) return '';
  return mediaUrlForPlayback(version.url, {
    localUrl: version.local_url,
    s3Url: version.url,
  }) || '';
}

export function jobSupportsSocialPublish(job) {
  if (!job || job.status !== 'completed') return false;
  if (!STORY_SOCIAL_PUBLISH_JOB_TYPES.has(job.job_type)) return false;
  return Boolean(resolveTaskJobPublishVideoUrl(job));
}

export function taskJobPublishTitle(job) {
  return String(job?.context_title || job?.title || '').trim();
}
